import { DEVICE_PIXEL_RATIO } from 'ol/has';
import Style from 'ol/style/Style';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import MultiPoint from 'ol/geom/MultiPoint';
import { COLORS } from 'cadenza/utils/colors/colors';
import { DEFAULT_OL_Z_INDEX } from 'cadenza/map/style/create-style';
import { createLineOlStyle } from 'cadenza/map/style/create-line-style';

const DEFAULT_MARKER_RADIUS = 5;
const DEFAULT_MARKER_BORDER_WIDTH = 2;
const DEFAULT_BORDER_COLOR = COLORS.GRAY_06_OPAQUE?.trim(); // colors may be undefined in tests
const DEFAULT_FILL_COLOR = COLORS.WHITE_09?.trim();

/*
 * Creates array of styles for saved route's steps. First style is always a stroke style for the line itself.
 * Second style in the array correspond to small circles marking start/end points of route segment or step line.
 */
export function createSavedLayerStepLineFeatureStyle (lineStyle) {
  const olLineStyle = createLineOlStyle(lineStyle);
  const olStartAndEndPointStyle = createStartEndPointStyle();
  return [ olLineStyle, olStartAndEndPointStyle ];
}

function createStartEndPointStyle () {
  const olStartAndEndPointStyle = new Style({
    geometry: feature => {
      const geometry = feature.getGeometry();
      const coordinates = [ geometry.getFirstCoordinate(), geometry.getLastCoordinate() ];
      return new MultiPoint(coordinates);
    },
    image: new Circle({
      radius: DEFAULT_MARKER_RADIUS,
      fill: new Fill({
        color: DEFAULT_FILL_COLOR
      }),
      stroke: new Stroke({
        color: DEFAULT_BORDER_COLOR,
        width: DEFAULT_MARKER_BORDER_WIDTH
      }),
      scale: 1 / DEVICE_PIXEL_RATIO
    })
  });
  olStartAndEndPointStyle.setZIndex(DEFAULT_OL_Z_INDEX);
  return olStartAndEndPointStyle;
}
